"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var MonitoringFileComponent = /** @class */ (function () {
    function MonitoringFileComponent() {
        this.txOnAccept = new core_1.EventEmitter();
        this.txOnReject = new core_1.EventEmitter();
        this.txOnRequestModelImage = new core_1.EventEmitter();
        this.modalActions = new core_1.EventEmitter();
    }
    MonitoringFileComponent.prototype.ngOnInit = function () {
    };
    Object.defineProperty(MonitoringFileComponent.prototype, "file", {
        get: function () {
            return this._file;
        },
        set: function (file) {
            this._file = file;
            if (this._file.accepted) {
                this.accepted = true;
                this.rejected = false;
            }
            this.validType = this._file.vehiclePart !== 'OTHER';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MonitoringFileComponent.prototype, "viewMode", {
        get: function () {
            return this._viewMode;
        },
        set: function (viewMode) {
            this._viewMode = viewMode;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MonitoringFileComponent.prototype, "description", {
        get: function () {
            return this._description;
        },
        set: function (description) {
            this._description = description;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MonitoringFileComponent.prototype, "vehiclePart", {
        get: function () {
            return this._vehiclePart;
        },
        set: function (vehiclePart) {
            this._vehiclePart = vehiclePart;
        },
        enumerable: true,
        configurable: true
    });
    MonitoringFileComponent.prototype.accept = function () {
        this.accepted = !this.accepted;
        this.rejected = false;
        this.txOnAccept.emit(this._file);
    };
    MonitoringFileComponent.prototype.reject = function () {
        this.modalActions.emit({ action: 'modal', params: ['open'] });
    };
    MonitoringFileComponent.prototype.emitRejection = function () {
        this.rejected = !this.rejected;
        this.accepted = false;
        this.txOnReject.emit(this._file);
    };
    MonitoringFileComponent.prototype.requestModelImage = function () {
        this.txOnRequestModelImage.emit(this._file);
    };
    MonitoringFileComponent.prototype.showEmptyState = function () {
        return this._file === null || !this._file.id;
    };
    MonitoringFileComponent.ctorParameters = function () { return []; };
    return MonitoringFileComponent;
}());
exports.MonitoringFileComponent = MonitoringFileComponent;
//# sourceMappingURL=monitoring-file.component.js.map


// WEBPACK FOOTER //
// monitoring-file.component.js